import UserClass from "./UserClass";
import Header from "./Header";
import Footer from "./Footer";

const About = () => {
	return (
		<>
			<Header />
			<UserClass name={"Rohit Mathur Class"} location={"Jaipur"} />
			<Footer />
		</>
	);
};

export default About;
